import biconfig from './biconfig'
import {processConfigHandlers} from 'powtoon-commons/biTracker/configUtils'
import {BITracker} from 'powtoon-commons/biTracker'
import trackingService from './userTrackingService'

import {createLogger} from 'logging'
const logger = createLogger('bitracker')

const biTracker = new BITracker(trackingService, logger)
biTracker.config(processConfigHandlers(biconfig))

export default biTracker

